import { Box, Chip, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";

const LabelChip = ({ label, sx = {} }) => {
  const colors = useColors();
  const maxLabelLength = 21;
  const truncatedLabel =
    label.length > maxLabelLength
      ? `${label.slice(0, maxLabelLength)}...`
      : label;

  return (
    <Chip
      key={label}
      sx={{
        background: colors.grey_8percent,
        color: colors.text_primary,
        border: "none",
        borderRadius: "6px",
        height: "18px",

        ...sx,
      }}
      label={
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          alignItems={"flex-end"}
        >
          <Typography variant="caption" key={label}>
            <Box
              style={{
                textDecoration: "none",
                borderBottom: "none",
              }}
            >
              <CustomToolTip
                title={label}
                placement={"top"}
                disableHoverListener={label.length <= maxLabelLength}
              >
                {truncatedLabel}
              </CustomToolTip>
            </Box>
          </Typography>
        </Box>
      }
    />
  );
};

export default LabelChip;
